"use strict";

/**
 * @generated SignedSource<<5362b3ddb20df6d18be894e6925f071b>>
 * @relayHash 2e7815f0ece179990dab3806bf89f926
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 43b2057f453bb8654896d1cda0d869d71cb3d00ad3d379c36a62d01429a63997

const node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }],
    v2 = {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "metadata": null,
      "name": "FleetModelSelect_HomepageQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [{
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "VehicleModel",
            "kind": "LinkedField",
            "name": "models",
            "plural": true,
            "selections": [{
              "args": null,
              "kind": "FragmentSpread",
              "name": "VehicleModelSelect_models"
            }],
            "storageKey": null
          }],
          "type": "VehicleMake",
          "abstractKey": null
        }],
        "storageKey": null
      }],
      "type": "Query",
      "abstractKey": null
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "FleetModelSelect_HomepageQuery",
      "selections": [{
        "alias": null,
        "args": v1 /*: any*/,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [{
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }, {
          "kind": "InlineFragment",
          "selections": [{
            "alias": null,
            "args": null,
            "concreteType": "VehicleModel",
            "kind": "LinkedField",
            "name": "models",
            "plural": true,
            "selections": [v2 /*: any*/, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPopular",
              "storageKey": null
            }, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }, {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "type": "VehicleMake",
          "abstractKey": null
        }, v2 /*: any*/],
        "storageKey": null
      }]
    },
    "params": {
      "id": "43b2057f453bb8654896d1cda0d869d71cb3d00ad3d379c36a62d01429a63997",
      "metadata": {},
      "name": "FleetModelSelect_HomepageQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "13dcd25608a0e02c089e0fee49aabf30";
export default node;